import React, { useState, useCallback, useRef, Fragment } from "react";
import PropTypes from "prop-types";
import { TextField, Button } from "@mui/material";
import VisibilityPasswordTextField from "../../../shared/components/VisibilityPasswordTextField";
import withStyles from '@mui/styles/withStyles';
import HighlightedInformation from "../../../shared/components/HighlightedInformation";
import FormDialog from "../../../shared/components/FormDialog";
import ButtonCircularProgress from "../../../shared/components/ButtonCircularProgress";
import { Auth, Amplify } from 'aws-amplify';
import aws_exports from '../../../aws-exports';
Amplify.configure(aws_exports);
const styles = (theme) => ({
  dialogContent: {
    paddingTop: theme.spacing(2),
  },
  dialogActions: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
});

function VerificationCode(props) {
  const { setStatus, onClose, setLoginStatus, status, openLoginDialog} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const codeRespEmail = useRef();
  const codeFromEmail = useRef();
  const newPassword = useRef();
  const newPasswordRepeat = useRef();
  const checkPasswordCode= useCallback(() => {

    if (
      newPassword.current.value !== newPasswordRepeat.current.value
    ) {
      setStatus("passwordsDontMatch");
      return;
    }
    setIsLoading(true);
    Auth.forgotPasswordSubmit(codeRespEmail.current.value, codeFromEmail.current.value, newPassword.current.value)
      .then(data =>
        setLoginStatus("successAccountFix").then(openLoginDialog()))
      .catch(err => console.log(err));
    setStatus("unknownError");
    setIsLoading(false);
  }, [setIsLoading, setStatus, setLoginStatus, onClose, codeRespEmail, codeFromEmail, newPassword, newPasswordRepeat]);


  return (
    <FormDialog
      loading={isLoading}
      onClose={onClose}
      open
      onFormSubmit={(e) => {
        e.preventDefault();
        checkPasswordCode();
      }}
      hideBackdrop
      hasCloseIcon
      headline="Forgot Password"
      maxWidth="s"
      content={
        <Fragment >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Email Address"
            inputRef={codeRespEmail}
            autoFocus
            autoComplete="off"
            type="email"
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Verification Code"
            inputRef={codeFromEmail}
            autoFocus
            autoComplete="off"
          />
          <VisibilityPasswordTextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={
              status === "passwordTooShort" || status === "passwordsDontMatch"
            }
            label="Password"
            inputRef={newPassword}
            autoComplete="off"
            onChange={() => {
              if (
                status === "passwordTooShort" ||
                status === "passwordsDontMatch"
              ) {
                setStatus(null);
              }
            }}
            helperText={(() => {
              if (status === "passwordTooShort") {
                return "Create a password at least 6 characters long.";
              }
              if (status === "passwordsDontMatch") {
                return "Your passwords dont match.";
              }
              return null;
            })()}
            FormHelperTextProps={{ error: true }}
            isVisible={isPasswordVisible}
            onVisibilityChange={setIsPasswordVisible}
          />
          <VisibilityPasswordTextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={
              status === "passwordTooShort" || status === "passwordsDontMatch"
            }
            label="Repeat Password"
            inputRef={newPasswordRepeat}
            autoComplete="off"
            onChange={() => {
              if (
                status === "passwordTooShort" ||
                status === "passwordsDontMatch"
              ) {
                setStatus(null);
              }
            }}
            helperText={(() => {
              if (status === "passwordTooShort") {
                return "Create a password at least 6 characters long.";
              }
              if (status === "passwordsDontMatch") {
                return "Your passwords dont match.";
              }
            })()}
            FormHelperTextProps={{ error: true }}
            isVisible={isPasswordVisible}
            onVisibilityChange={setIsPasswordVisible}
          />
          {(() => {
            if (status === "unknownError"){
              return (<HighlightedInformation>
                Please ensure all information was entered correctly and tryin submitting again.
              </HighlightedInformation>)
            }
            if (status === "successAccountFix"){
              return (<HighlightedInformation>
                You have successfully reset your password, please login.
              </HighlightedInformation>)
            }
          })()}
        </Fragment>
      }
      actions={
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          color="secondary"
          disabled={isLoading}
        >
          Submit
          {isLoading && <ButtonCircularProgress />}
        </Button>
      }
    />
  );
}

VerificationCode.propTypes = {
  onClose: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  setStatus: PropTypes.func.isRequired,
  setLoginStatus: PropTypes.func.isRequired,
  openLoginDialog:PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(VerificationCode);
